class Date_Time_Unit {
    static path = 'values/date-time-unit';

    constructor(mutator){
        this.bgcolor = '#9b9998';
        this.title = 'Extract Date/Time Unit';
        this.desc = 'Extract the year/month/day/hour/minute from a date.';
        this.values = ["Year", "Month", "Day", "Hour", "Minute"];
        this.properties = {value: 'Year'}

        this.addInput("Date", "date,datetime");
        this.addOutput("Unit", "number,integer");
        this.addWidget("combo","",'Year',{ property: "value", values: this.values } );
    }

    getTitle() {
        if (this.flags.collapsed) {
            return 'Extract '+this.properties.value;
        }
        return this.title;
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"].length > 0 ? this.properties["value"] : 'Unit';
    }

}

module.exports = Date_Time_Unit
